import React, { useContext, useEffect, useRef, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import PropTypes from 'prop-types';
import List from '../../commonComponents/lists/List';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import translate from '../../commonComponents/translate';
import JourneyItem from './JourneyItem';
import TextFilter from '../../commonComponents/lists/filters/TextFilter';
import MarketInfosContext from '../../contextProviders/MarketInfosContext';
import { useDimensions } from '../../services/customHooks';
import JourneyFilters from './JourneyFilters';
import CurrencyProp from '../profile/propTypes/currencyProp';
import CourseTagProp from '../../commonComponents/propTypes/CourseTagProp';
import PriceRangeProp from '../academy/propTypes/PriceRangeProp';
import LoggedUserContext from '../../contextProviders/LoggedUserContext';
import useTrailerTrigger from '../../services/useTrailerTrigger';
import TrailerModal from '../../commonComponents/TrailerModal';

function JourneysAcademyList(props) {
  const {
    t,
    query,
    languages,
    onChange,
    currencies,
    tags,
    onQueryChange,
    priceRange,
  } = props;
  const { loggedUser } = useContext(LoggedUserContext);
  const { isMobile } = useDimensions();
  const [isFiltersMobileOpen, setIsFiltersMobileOpen] = useState(false);
  const tableId = 'sessionList';
  const tableEl = useRef(null);
  const [trailerUrl, closeTrailer] = useTrailerTrigger();

  const handleMobileFilter = () => {
    setIsFiltersMobileOpen(prevState => !prevState);
  };

  const columns = [
    {
      field: 'name',
      textAlign: 'center',
      title: t('academy_name'),
      template: item =>
        renderToStaticMarkup(
          <JourneyItem
            t={t}
            journey={item}
            languages={languages}
            showPromotion
            showTeaserVideo
          />,
        ),
    },
  ];
  useEffect(() => {
    $('#searchInput').val(query.search);
  }, [query.search]);
  const { marketInfos } = useContext(MarketInfosContext);
  const dataSourceParams = {
    country: marketInfos.localCountry,
    currency: marketInfos.localCurrency,
  };
  if (!loggedUser?._id && marketInfos?.localLanguage) {
    dataSourceParams.notLoggedLanguage = marketInfos.localLanguage;
  }
  return (
    <>
      <div className="academy-list-search row fix-on-mobile">
        {isMobile && (
          <div className="col-lg-0 col-2 filter-button-shop-container">
            <button type="button" onClick={handleMobileFilter}>
              <i className="fa fa-filter" />
            </button>
          </div>
        )}
        <div className="col-lg-12 col-10 search-container-mobile">
          <TextFilter
            id="searchInput"
            onChange={onChange('search')}
            placeholder={t('search')}
            value={query.search}
          />
        </div>
      </div>
      {isMobile && isFiltersMobileOpen && (
        <JourneyFilters
          currencies={currencies}
          languages={languages}
          selected={query}
          tags={tags}
          onChange={onQueryChange}
          onPriceChange={onChange}
          priceRange={priceRange}
        />
      )}
      <List
        ref={tableEl}
        columns={columns}
        id={tableId}
        dataSourceURL="/table/journey/list?isPublic=true"
        dataSourceHeaders={{
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
        }}
        dataSourceParams={dataSourceParams}
        query={{ ...query }}
      />
      <TrailerModal videoUrl={trailerUrl} onClose={closeTrailer} />
    </>
  );
}

JourneysAcademyList.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  query: PropTypes.shape({
    category: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  onChange: PropTypes.func.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape(CourseTagProp.propType)),
  priceRange: PropTypes.shape(PriceRangeProp.propType).isRequired,
};

JourneysAcademyList.defaultProps = {
  tags: [],
};

export default translate(JourneysAcademyList);
